import { defineStore } from "pinia";

export const useModalVideo = defineStore("modalVideo", () => {
  const modalIsOpen = ref(false);
  const videoUrl = ref("");
  const videoEmbedCode = ref("");

  const closeModal = () => {
    modalIsOpen.value = false;
  };

  const openModal = (url) => {
    videoUrl.value = url;
    videoEmbedCode.value = getEmbedCodeByUrl(videoUrl.value);
    modalIsOpen.value = true;
  };

  return {
    closeModal,
    modalIsOpen,
    openModal,
    videoEmbedCode,
    videoUrl,
  };
});
